module.exports = __webpack_public_path__ + "static/img/app-mobile2@2x.7cfd75d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-mobile2@2x.png
// module id = qnFb
// module chunks = 1